import React, { createContext, useContext, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAdminProducers } from '@/hooks/useAdminProducers';

type AdminProducerContextType = ReturnType<typeof useAdminProducers>;

const AdminProducerContext = createContext<AdminProducerContextType | null>(null);

export function AdminProducerProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const disableListFetch = location.pathname === '/app/admin/producers';
  const adminProducers = useAdminProducers({ disableListFetch });

  return (
    <AdminProducerContext.Provider value={adminProducers}>
      {children}
    </AdminProducerContext.Provider>
  );
}

export function useAdminProducerContext() {
  const context = useContext(AdminProducerContext);
  if (!context) {
    throw new Error('useAdminProducerContext must be used within AdminProducerProvider');
  }
  return context;
}
